import axios from '../axios';
//  一地接入项目对接列表接口
export function getSoftTestList(params = {}) {
    return axios({
        method: 'post',
        url: '/tProjectProcessingApplication/selectId',
        data: params
    })
}
//  一地接入选中市区后附件的接口
export function getCityCodeAttachment(params = {}) {
    return axios({
        method: 'get',
        url: '/tProvincialGeneral/selectByCode',
        params
    })
}
//  一地接入附件下载的接口
export function attachmentDownLoad(params = {}) {
    return axios({
        method: 'get',
        url: '/tProvincialGeneral/downLoadUrl',
        responseType: 'arraybuffer',
        params
    })
}
// 一地接入软硬件测试——文件上传
export function attachmentUpLoad(params = {}) {
    return axios({
        method: 'post',
        url: '/fastdfs/upload',
        data: params
    })
}
//  一地接入所有市区接口
export function getCityCodeLists(params = {}) {
    return axios({
        method: 'get',
        url: '/dict/citys',
        params
    })
}
    //  一地接入所有市区接口
export function getCityCodeList(params = {}) {
    return axios({
        method: 'get',
        url: '/dict/selectAreaCode',
        params
    })

}
// 一地接入软硬件测试——新增
export function generalAdd(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/insert',
        data: params
    })
}
// 一地接入软硬件测试——编辑
export function generalEdit(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/update',
        data: params
    })
}
// 一地接入软硬件测试——审核通过
export function passAudit(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/updateByStatus',
        data: params
    })
}
//  一地接入软硬件测试——删除
export function generalDelete(params = {}) {
    return axios({
        method: 'get',
        url: '/tProvincialGeneral/delete',
        params
    })
}
//  一地接入项目——详情
export function generalDetail(params = {}) {
    return axios({
        method: 'get',
        url: '/tProjectProcessingApplication/id',
        params
    })
}
// 一地接入软硬件测试——审核通用
export function auditGeneral(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/updateByStatus',
        data: params
    })
}
//  一地接入软硬件测试列表接口
export function getSoftTestLists(params = {}) {
    return axios({
        method: 'get',
        url: '/tProvincialGeneral/queryByPage',
        params
    })
}
//  一地接入软硬件测试详情接口
export function generalDetails(params = {}) {
    return axios({
        method: 'get',
        url: '/tProvincialGeneral/uuid',
        params
    })
}
//  一地接入查询所有处理部门
export function queryDepartment(params = {}) {
    return axios({
        method: 'get',
        url: 'tProvincialGeneral/inquiryDepartment',
        params
    })
}
//  一地接入查询所有处理部门
export function department(params = {}) {
    return axios({
        method: 'get',
        url: 'tProvincialGeneral/department',
        params
    })
}
//  一地接入投诉列表接口
export function getSelectByComplaint(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/selectByComplaint',
        data: params
    })
}
// 一地接入投诉——新增
export function insertByComplaintAdd(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/insertByComplaint',
        data: params
    })
}
//  一地接入投诉——详情
export function queryByComplaintDetail(params = {}) {
    return axios({
        method: 'get',
        url: '/tProvincialGeneral/queryByComplaint',
        params
    })
}
//  一地接入投诉——删除
export function deleteByComplaint(params = {}) {
    return axios({
        method: 'get',
        url: '/tProvincialGeneral/deleteByComplaint',
        params
    })
}
//  一地接入投诉——处理
export function handle(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/updateStatusByComplaint',
        data: params
    })
}
//  一地接入查询所有处理部门
export function departmentCity(params = {}) {
    return axios({
        method: 'get',
        url: 'tProvincialGeneral/departmentCity',
        params
    })
}
//  一地接入-关联密钥申请选项  type(投诉类型：0：软硬件测试密钥申请投诉1：项目对接密钥申请投诉)
export function getTypeArr(params = {}) {
    return axios({
        method: 'post',
        url: '/tProvincialGeneral/type',
        data: params
    })
}
